<template>
  <v-container fluid fill-height>
    <v-row
      class="background-color-white mb-2 text-center"
      v-if="user && user.role == 'SAMPLER_SOLENA'"
    >
      <v-col class="py-0">
        <span>
          {{ companyName }}
        </span>
      </v-col>
    </v-row>
    <ClientList />
    <!-- <ProspectList v-if="switchList" @clientAdded="switchList = false" /> -->
    <v-container>.</v-container>
    <v-footer
      fixed
      class="text-center d-flex justify-center align-center px-0 py-0"
      max-height="60px"
    >
      <!-- <span class="text-caption"> D.R. © Solena Ag, Inc. 2021</span> -->
      <v-container fluid style="background-color: #52b61b" class="ma-0 pa-0">
        <v-row align="center" class="ma-0 pa-0">
          <v-col class="ma-2 pa-0">
            <span class="white--text">{{translations.label_clients}}</span>
          </v-col>
          <!-- <v-col class="d-flex justify-center ma-0 pa-0">
            <v-switch v-model="switchList" color="white"></v-switch>
          </v-col> -->
          <!-- <v-col class="ma-1 pa-0">
            <span class="white--text">{{translations.label_prospects}}</span>
          </v-col> -->
        </v-row>
      </v-container>
    </v-footer>
    <ChangeDistributorModal
      v-if="showChangeDistributorModal"
      v-model="showChangeDistributorModal"
      @updateData="updateData"
    />
  </v-container>
</template>
<script>
//vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//components
import ClientList from "@/components/home/ClientList.vue";
import ProspectList from "@/components/home/ProspectList.vue";
import ChangeDistributorModal from "@/components/home/modals/ChangeDistributorModal.vue";
export default {
  components: {
    ClientList,
    ProspectList,
    ChangeDistributorModal,
  },
  data: () => ({
    distributionOrganizationId: localStorage.getItem(
      "distributionOrganizationId"
    ),
    switchList: false,
    loading: false,
    showChangeDistributorModal: false,
    user: null,
    companyName: null,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("user", ["search", "changeDistributor"]),
  },
  async mounted() {
    let user = JSON.parse(localStorage.getItem("user"));
    localStorage.removeItem("clientId");
    localStorage.removeItem("client");
    this.SET_CLIENT("");
    
    if (
      user.role == "SAMPLER_SOLENA" ||
      user.role == "GEN_MANAGER" ||
      user.role == "MANAGER"
      
    ) {
      this.SET_APPBAR_OPTIONS({
        leftButton: "list_seller",
        funcLeftButton: this.some,
        rightButton: "search_prospect",
      });
    } else {
      if(user.role == "SELLER" || user.role == "ADVISOR"){
        this.SET_APPBAR_OPTIONS({
        leftButton: "list_seller",
        funcLeftButton: this.some,
        rightButton: "search_prospect",
        likeButton: "like_button",
        openLikeButton: this.openLikeClient,
      });
      }else{
        this.SET_APPBAR_OPTIONS({
        leftButton: "list_seller",
        funcLeftButton: this.some,
        rightButton: "search_seller",
        likeButton: "like_button",
        openLikeButton: this.openLikeClient,
      });
      }
 
    }

    // if (this.$route.params.section == "client") {
    //   this.switchList = false;
    // } else if (this.$route.params.section == "prospect") {
    //   this.switchList = true;
    // }

    if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
      this.$router.push("/territory").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    }
  },
  created() {
    this.updateData();
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("user", ["SET_CLIENT", "SET_CHANGE_DISTRIBUTOR"]),
    openLikeClient() {
      this.$router.push(`/favorite`);
    },
    updateData() {
      this.showChangeDistributorModal = false;
      let user = JSON.parse(localStorage.getItem("user"));
      this.user = user;
      this.companyName = localStorage.getItem("companyDistributorName");
    },
  },
  watch: {
    // switchList(value) {
    //   if (value) {
    //     this.SET_APPBAR_OPTIONS({
    //       leftButton: "list_seller",
    //       funcLeftButton: this.some,
    //       rightButton: "search_prospect",
    //     });
    //     if ("prospect" != this.$route.params.section) {
    //       this.$router.replace({
    //         params: {
    //           section: "prospect",
    //         },
    //       });
    //     }
    //   } else {
    //     let user = JSON.parse(localStorage.getItem("user"));
    //     if (
    //       user.role == "SAMPLER_SOLENA" ||
    //       user.role == "GEN_MANAGER" ||
    //       user.role == "MANAGER"
    //     ) {
    //       this.SET_APPBAR_OPTIONS({
    //         leftButton: "list_seller",
    //         funcLeftButton: this.some,
    //         rightButton: "search_seller",
    //       });
    //     } else {
    //       this.SET_APPBAR_OPTIONS({
    //         leftButton: "list_seller",
    //         funcLeftButton: this.some,
    //         rightButton: "search_seller",
    //         likeButton: "like_button",
    //         openLikeButton: this.openLikeClient,
    //       });
    //     }
    //     if ("client" != this.$route.params.section) {
    //       this.$router.replace({
    //         params: {
    //           section: "client",
    //         },
    //       });
    //     }
    //   }
    // },
    changeDistributor(value) {
      if (value) {
        this.SET_CHANGE_DISTRIBUTOR(false);
        this.showChangeDistributorModal = true;
      }
    },
  },
};
</script>

<style scoped>
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}

.background-color-white {
  background-color: white;
}
</style>
